@if (state.config.betsConfig.qualifiers) {
  <mat-card appearance="outlined" class="oo-betting-form">
    <mat-card-header>
      <mat-card-title>Qualifiers ({{ state.config.betsConfig.qualifiers.points }})</mat-card-title>
      <mat-card-subtitle>Teams to qualify from stage</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <oo-dropdowns-betting [bettingForm]="state.bettingForm"
                            [dropdowns]="state.qualifiersOptions"
                            [initValue]="state.betting?.qualifiers"
                            key="qualifiers"
                            [multi]="true"
                            [multipleDropdowns]="false"
                            [numOfSelections]="state.config.numOfQualifiers">
      </oo-dropdowns-betting>
    </mat-card-content>
  </mat-card>
}

@if (state.config.betsConfig.notQualified) {
  <mat-card appearance="outlined" class="oo-betting-form">
    <mat-card-header>
      <mat-card-title>Not Qualified ({{ state.config.betsConfig.notQualified.points }})</mat-card-title>
      <mat-card-subtitle>Teams not to qualify from stage</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <oo-dropdowns-betting [bettingForm]="state.bettingForm"
                            [dropdowns]="state.notQualifiedOptions"
                            [initValue]="state.betting?.notQualified"
                            key="notQualified"
                            [multi]="true"
                            [multipleDropdowns]="false"
                            [numOfSelections]="state.config.numOfNotQualified">
      </oo-dropdowns-betting>
    </mat-card-content>
  </mat-card>
}

@if (state.config.betsConfig.firstPlace) {
  <mat-card appearance="outlined" class="oo-betting-form">
    <mat-card-header>
      <mat-card-title>First Place ({{ state.config.betsConfig.firstPlace.points }})</mat-card-title>
      <mat-card-subtitle>Team to take the first place</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <oo-dropdowns-betting [bettingForm]="state.bettingForm"
                            [dropdowns]="state.firstPlaceOptions"
                            [initValue]="state.betting?.firstPlace"
                            key="firstPlace"
                            [multi]="false"
                            [multipleDropdowns]="false">
      </oo-dropdowns-betting>
    </mat-card-content>
  </mat-card>
}

@if (state.config.betsConfig.lastPlace) {
  <mat-card appearance="outlined" class="oo-betting-form">
    <mat-card-header>
      <mat-card-title>Last Place ({{ state.config.betsConfig.lastPlace.points }})</mat-card-title>
      <mat-card-subtitle>Team to take the last place</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <oo-dropdowns-betting [bettingForm]="state.bettingForm"
                            [dropdowns]="state.lastPlaceOptions"
                            [initValue]="state.betting?.lastPlace"
                            key="lastPlace"
                            [multi]="false"
                            [multipleDropdowns]="false">
      </oo-dropdowns-betting>
    </mat-card-content>
  </mat-card>
}

@if (state.config.betsConfig.mostScoringTeam) {
  <mat-card appearance="outlined" class="oo-betting-form">
    <mat-card-header>
      <mat-card-title>Most scoring team ({{ state.config.betsConfig.mostScoringTeam.points }})</mat-card-title>
      <mat-card-subtitle>Team to score most amount of goals in league stage</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <oo-dropdowns-betting [bettingForm]="state.bettingForm"
                            [dropdowns]="state.mostScoringTeamOptions"
                            [initValue]="state.betting?.mostScoringTeam"
                            [key]="'mostScoringTeam'"
                            [multi]="state.isSubmissionMode"
                            [multipleDropdowns]="false">
      </oo-dropdowns-betting>
    </mat-card-content>
  </mat-card>
}

@if (state.config.betsConfig.leastScoringTeam) {
  <mat-card appearance="outlined" class="oo-betting-form">
    <mat-card-header>
      <mat-card-title>Least scoring team ({{ state.config.betsConfig.leastScoringTeam.points }})</mat-card-title>
      <mat-card-subtitle>Team to score least amount of goals in league stage</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <oo-dropdowns-betting [bettingForm]="state.bettingForm"
                            [dropdowns]="state.leastScoringTeamOptions"
                            [initValue]="state.betting?.leastScoringTeam"
                            [key]="'leastScoringTeam'"
                            [multi]="state.isSubmissionMode"
                            [multipleDropdowns]="false">
      </oo-dropdowns-betting>
    </mat-card-content>
  </mat-card>
}

@if (state.config.betsConfig.teamToConceiveMostGoals) {
  <mat-card appearance="outlined" class="oo-betting-form">
    <mat-card-header>
      <mat-card-title>Team that conceives most goals ({{ state.config.betsConfig.teamToConceiveMostGoals.points }})
      </mat-card-title>
      <mat-card-subtitle>Team to conceive most amount of goals in league stage</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <oo-dropdowns-betting [bettingForm]="state.bettingForm"
                            [dropdowns]="state.teamToConceiveMostGoalsOptions"
                            [initValue]="state.betting?.teamToConceiveMostGoals"
                            [key]="'teamToConceiveMostGoals'"
                            [multi]="state.isSubmissionMode"
                            [multipleDropdowns]="false">
      </oo-dropdowns-betting>
    </mat-card-content>
  </mat-card>
}

@if (state.config.betsConfig.teamToConceiveLeastGoals) {
  <mat-card appearance="outlined" class="oo-betting-form">
    <mat-card-header>
      <mat-card-title>Team that conceives least goals ({{ state.config.betsConfig.teamToConceiveLeastGoals.points }})
      </mat-card-title>
      <mat-card-subtitle>Team to conceive least amount of goals in league stage</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <oo-dropdowns-betting [bettingForm]="state.bettingForm"
                            [dropdowns]="state.teamToConceiveLeastGoalsOptions"
                            [initValue]="state.betting?.teamToConceiveLeastGoals"
                            [key]="'teamToConceiveLeastGoals'"
                            [multi]="state.isSubmissionMode"
                            [multipleDropdowns]="false">
      </oo-dropdowns-betting>
    </mat-card-content>
  </mat-card>
}

@if (state.config.betsConfig.underOver) {
  <mat-card appearance="outlined" class="oo-betting-form">
    <mat-card-header>
      <mat-card-title>Under or over goals</mat-card-title>
      <mat-card-subtitle>
        Total number of goals during the league stage Under or over/equal
        to {{ state.config.betsConfig.underOver.goals }} ({{ state.config.betsConfig.underOver.points }})
      </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <oo-button-group-betting [bettingForm]="state.bettingForm"
                               [initValue]="state.betting?.underOver"
                               [key]="'underOver'"
                               [options]="state.underOverOptions">
      </oo-button-group-betting>
    </mat-card-content>
  </mat-card>
}
